import { useMemo } from 'react';
import * as v from 'valibot';

import {
  AdventWinnersSchema,
  type AdventWinner,
} from '@/competitions/2023/december/pages/LandingPage/schemas.ts';
import type { CompetitionWinner } from '@/lib/api/requests.ts';

import AdventDay from './AdventDay/index.ts';

const days = Array.from({ length: 24 }, (_, index) => index + 1);

interface CalendarCompetitionProps {
  winners: CompetitionWinner[];
}

const CalendarCompetition = ({ winners: winnersProp }: CalendarCompetitionProps) => {
  const winners = useMemo(() => v.parse(AdventWinnersSchema, winnersProp), [winnersProp]);
  const winnersByDay = useMemo(
    () =>
      winners.reduce(
        (acc, winner) => {
          acc[winner.meta.day] ??= [];
          acc[winner.meta.day]!.push(winner);
          return acc;
        },
        {} as Record<number, AdventWinner[] | undefined>,
      ),
    [winners],
  );

  return (
    <div className="grid grid-cols-3 gap-2.5 *:aspect-square sm:grid-cols-5 sm:[&>.day-24]:col-span-2 sm:[&>.day-24]:aspect-auto">
      {days.map((day) => (
        <AdventDay key={day} className={`day-${day}`} day={day} winners={winnersByDay[day] ?? []} />
      ))}
    </div>
  );
};

export default CalendarCompetition;
